import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

// Component
import EditStaticPageManage from '../../../components/siteadmin/EditStaticPage/EditStaticPage';

// Query
import editStaticPage from './editStaticPage.graphql';
import NotFound from '../../notFound/NotFound';
import Loader from '../../../components/Loader/Loader';
import { withQuery } from '../../../hoc/withGraphql';

import s from './EditStaticPage.css';

class EditStaticPage extends React.Component {

    static propTypes = {
        title: PropTypes.string.isRequired,
        blogId: PropTypes.number.isRequired,
        editStaticPageData: PropTypes.shape({
            loading: PropTypes.bool,
            getEditStaticPage: PropTypes.object
        }),
    };


    render() {
        const { editStaticPageData, title } = this.props;

        if (editStaticPageData?.loading) return <div><Loader type={"text"} /></div>

        if (editStaticPageData && editStaticPageData.getEditStaticPage === null) {
            return <NotFound />
        }

        return (
            <EditStaticPageManage
                title={title} initialValues={editStaticPageData.getEditStaticPage}
            />
        );
    }
}

export default compose(
    withStyles(s),
    withQuery(editStaticPage, {
        name: 'editStaticPageData',
        options: (props) => ({
            variables: {
                id: props.pageId,
            },
            fetchPolicy: 'network-only',
            ssr: false
        })
    }),
)(EditStaticPage);